import * as Yup from "yup";
import { formatPrecisaoFloat } from "../../../../utils";

const centroCustoRateioSchema = Yup.object().shape({
  centroCustoId: Yup.number().required("Centro de Custo"),
  percentual: Yup.number()
    .required("Percentual do Centro de Custo")
    .min(0, "Percentual do Centro de Custo não pode ser negativo"),
});

const rateioSchema = Yup.object().shape({
  planoFinanceiroId: Yup.number().required("Plano Financeiro"),
  valor: Yup.number()
    .required("Valor do Rateio")
    .min(0, "Valor do Rateio não pode ser negativo"),
});

const contaPagarValidator = Yup.object().shape({
  status: Yup.string().nullable(),
  numeroTitulo: Yup.string().nullable(),
  origem: Yup.string().nullable(),
  pessoaId: Yup.number().required("Recebedor"),
  meioPagamentoId: Yup.number().required("Meio de Pagamento"),
  dataCompetencia: Yup.date().nullable(),
  dataVencimento: Yup.date().required("Data Vencimento"),
  //planoFinanceiroId: Yup.number().nullable(),
  //centroCustoId: Yup.number().nullable(),
  historico: Yup.string().nullable(),
  pagamentosParciais: Yup.string().nullable(),
  valor: Yup.number().required("Valor"),
  acrescimo: Yup.string().nullable(),
  desconto: Yup.string().nullable(),
  observacaoList: Yup.array(),
  rateiosCentroCustoList: Yup.array()
    .of(centroCustoRateioSchema)
    .nullable()
    .test(
      "unique-centroCustoId",
      "IDs de Centro de Custo diferentes",
      function (list) {
        if (!list?.length) return true;
        const ids = list.map((item) => item.centroCustoId);
        const validItems = list.filter(
          (item) => item && typeof item.centroCustoId === "number"
        );
        if (validItems.length !== list.length) return true;
        const uniqueIds = new Set(ids);
        return ids.length === uniqueIds.size;
      }
    )
    .test(
      "sum-centroCustoRateio-valor",
      "Rateios devem ser igual a 100% — ",
      function (list) {
        if (!list?.length) return true;
        const sumCentroCustoPercentual = list.reduce(
          (sum, item) => sum + item.percentual,
          0
        );
        return formatPrecisaoFloat(sumCentroCustoPercentual) === 100;
      }
    ),
  rateiosPlanoFinanceiroList: Yup.array()
    .of(rateioSchema)
    .nullable()
    .test(
      "unique-planoFinanceiroId",
      "IDs de Plano Financeiro diferentes",
      function (list) {
        if (!list?.length) return true;
        const ids = list.map((item) => item.planoFinanceiroId);
        const validItems = list.filter(
          (item) => item && typeof item.planoFinanceiroId === "number"
        );
        if (validItems.length !== list.length) return true;
        const uniqueIds = new Set(ids);
        return ids.length === uniqueIds.size;
      }
    )
    .test(
      "sum-rateios-valor",
      "Rateios devem igualar o total — ",
      function (list) {
        if (!list?.length) return true;
        const { valor, acrescimo, desconto } = this.parent;
        const totalExpected =
          valor + parseFloat(acrescimo || 0) - parseFloat(desconto || 0);
        const sumRateiosValor = list.reduce((sum, item) => sum + item.valor, 0);
        return (
          formatPrecisaoFloat(sumRateiosValor) ===
          formatPrecisaoFloat(totalExpected)
        );
      }
    ),
  pagamentos: Yup.array()
    .of(
      Yup.object({
        dataPagamento: Yup.date().required("Data de pagamento"),
        recebedorId: Yup.number().required("Recebedor"),
        meioPagamentoId: Yup.number().required("Meio de pagamento"),
        atraso: Yup.number().nullable(),
        multa: Yup.string().nullable(),
        juros: Yup.string().nullable(),
        desconto: Yup.number().nullable(),
        valorTitulo: Yup.number().required("Valor do Título"),
        valor: Yup.number().required("Valor Pago"),
      })
    )
    .nullable(),
});

export default contaPagarValidator;
